<template>
  <div class="singIn register">
    <div class="logo">
      <div class="backIcon">
        <i
          class="el-icon-back cursor"
          @click="goBack"></i>
      </div>
      <div class="tvuLogo">
        <!-- <img src="./../assets/img/TVU networks Copy.png" alt=""> -->
      </div>
    </div>
    <div class="formBody">
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.resetPsw')}}</p>
        <p class="tvuDescribe">{{$t('lang.resetPswInfo')}}</p>
      </div>
      <div class="singInForm">
        <div class="exchange pswArea">
          <el-input
            class="input"
            minlength="8"
            tabindex='1'
            type="password"
            maxlength="64"
            @keyup.enter.native="nextOpaertaion"
            @input="checkPsd"
            @focus="focusInput('psd')"
            @blur="blurInput"
            v-model="password"
            show-password
            :placeholder="$t('lang.pswFormat')"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.pswtip')}}</span>
          </div>
        </div>
        <!-- <div class="pswTip" v-show="isShowStrength">
					<div class="pswBox">
						<div v-for="i in 6" :key="i" :class="[i<=strengthNum?'active':'','text']"></div>
					</div>
					<div class="strongTip" >
						<span class="strength">{{$t('lang.pswStrength')}}:</span>
						<span class="length" v-if="strengthNum==2">{{$t('lang.low')}}</span>
						<span class="length" v-else-if="strengthNum==4">{{$t('lang.middle')}}</span>
						<span class="length" v-else-if="strengthNum==6">{{$t('lang.high')}}</span>
					</div>
				</div> -->
        <div class="exchange comfirmarea">
          <el-input
            class="input"
            minlength="8"
            tabindex='2'
            type="password"
            maxlength="64"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput"
            @blur="blurInput"
            v-model="comfirmPassword"
            show-password
            :placeholder="$t('lang.comfirmPsw')"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.pswInconsist')}}</span>
          </div>
        </div>
        <div class="confirmArea">
          <el-button
            class="confirmBtn cursor"
            v-repeat-click="{event:nextOpaertaion}"
            :disabled='isDisabeBtn'
            :loading="isLoading">{{$t('lang.done')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
const sha512 = require('js-sha512')

export default {
  name: 'CreateAccount',
  data () {
    return {
      password: '',
      comfirmPassword: '',
      isShowStrength: false,
      strengthNum: 0,
      isDisabeBtn: true,
      emailErrorTip: '',
      isLoading: false
    }
  },
  mounted () {

  },
  watch: {
    password: function (newVal) {
      if (!newVal || !this.comfirmPassword) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
      // if(newVal){
      // 	this.isShowStrength = true;
      // 	this.strengthNum = this.checkPassWord(newVal);
      // }else{
      // 	this.strengthNum = 0;
      // 	this.isShowStrength = false;
      // }
    },
    comfirmPassword: function (newVal) {
      if ($('.comfirmarea').hasClass('errorInput')) {
        $('.comfirmarea').removeClass('errorInput')
      }
      if (!newVal || !this.password) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    }

  },
  computed: {
    emailCode () {
      return this.$store.state.emailCode
    },
    email () {
      return this.$store.state.userInfo.email
    },
    urlHref () {
      return this.$store.state.href
    }
  },
  methods: {
    checkPassWord (value) {
      // 0： 表示第一个级别 1：表示第二个级别 2：表示第三个级别
      // 3： 表示第四个级别 4：表示第五个级别
      let modes = 0

      if (value.length < 6) { // 最初级别
        return 2
      }
      if (/\d/.test(value)) { // 如果用户输入的密码 包含了数字
        modes++
      }
      if (/[a-z]/.test(value)) { // 如果用户输入的密码 包含了小写的a到z
        modes++
      }
      if (/[A-Z]/.test(value)) { // 如果用户输入的密码 包含了大写的A到Z
        modes++
      }
      if (/\W/.test(value)) { // 如果是非数字 字母 下划线
        modes++
      }
      switch (modes) {
        case 1:
          return 2
        case 2:
          return 4
        case 3:
          return 6
        case 4:
          return 6
      }
    },
    goBack () {
      // ga('send', 'event', 'newUserService-changePsw-goBack', 'click')
      gtag('event', 'newUserService-changePsw-goBack')
      this.$router.go(-1)
    },
    nextOpaertaion () {
      // ga('send', 'event', 'newUserService-changePsw-changepsw', 'click')
      gtag('event', 'newUserService-changePsw-changepsw')
      if (this.isLoading) {
        return
      }
      if (!this.checkPsd(this.password)) {
        $('.pswArea').addClass('errorInput').find('.warning').removeClass('info')
        return
      }
      // if(!this.password||!this.comfirmPassword){
      // 	this.isDisabeBtn = true;
      // 	return;
      // }else{
      // 	this.isDisabeBtn = false;
      // }
      if (this.password != this.comfirmPassword) {
        $('.comfirmarea').addClass('errorInput')
        return
      }
      if (this.password.length < 8) {
        this.$message({
          message: this.$t('lang.pswtip'),
          type: 'error',
          duration: 3000
        })
        return
      }
      this.isLoading = true
      this.axios.post(
        '/userGroup/user-group/login/resetPassword',
        this.qs.stringify({
          email: this.email,
          password: sha512(this.password),
          confirmPassword: sha512(this.comfirmPassword),
          verifyCode: this.emailCode
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        this.isLoading = false
        if (res.data.errorCode == '0x0') {
          // let href = window.location.href;
          // let params;
          // if(href.includes('?')){
          // 	params = decodeURIComponent(href).split('?')[1].split('&');
          // }else{
          // 	if(this.urlHref.includes('?')){
          // 		params = decodeURIComponent(this.urlHref).split('?')[1].split('&');
          // 	}else{
          // 		this.$router.push({path: '/'});
          // 		return;
          // 	}
          // }
          // let url,serviceName;
          // params.forEach(item=>{
          // 	if(item.includes('url=')){
          // 		url = item.split('url=')[1];
          // 	}else if(item.includes('serviceName=')){
          // 		serviceName = item.split('serviceName=')[1];
          // 	}
          // })
          // var exdate = new Date(); //获取时间
          // exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 1); //保存的天数
          // window.document.cookie = "userPwd" + "=" + window.btoa(this.comfirmPassword) + ";path=/;expires=" + exdate.toGMTString();
          const params = new URLSearchParams(location.search.slice(1))

          if (params.get('email')) {
            // params.delete('email')
            // params.delete('activeCode')
            // location.href = location.origin + location.pathname + '?' + params.toString() + '#/'
            location.href = location.href.replace(/&email=.+&/, '&').replace(/&activeCode=.+#/, '#').replace('/changePsw', '/')
          } else {
            this.$router.push({ path: '/' })
          }
          // this.$router.push({path: '/', query: {url: url,serviceName:serviceName}});
          // if(url){
          // 	this.$router.push({path: '/', query: {url: url,serviceName:serviceName}});
          // }else{
          // 	this.$router.push({path: '/'});
          // }
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    focusInput (event) {
      if (event && event == 'psd') {
        if (!this.checkPsd(this.password) && !$('.pswArea').hasClass('errorInput')) {
          $('.pswArea').removeClass('errorInput').find('.warning').addClass('info')
          $('.pswArea').find('.tip').css({
            display: 'inline-block',
            color: 'rgba(51,171,79,1)'
          })
        }
      } else {
        $(event.target).parent().prev('.tip').css({
          display: 'inline-block',
          color: 'rgba(51,171,79,1)'
        })
      }
    },
    blurInput () {
      $(event.target).parent().prev('.tip').css('color', 'rgba(153,153,153,1)')
    },
    checkPsd (val) {
      const reUpper = /[A-Z]/
      const reLower = /[a-z]/
      const reNum = /[0-9]/
      const reLen = /^.{8,64}$/
      // const str = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
      // const str = /[`~!@#$^&*()=|{}':;',\\[\\].<>《》\/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]/g
      // 这种写法需要中英文分开写，否则不生效
      // const strEn = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/g
      // const strCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/g
      const patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
      let count = 0

      if (reLower.test(val)) {
        ++count
      }
      if (reUpper.test(val)) {
        ++count
      }
      if (reNum.test(val)) {
        ++count
      }
      if (patrn.test(val)) {
        ++count
      }
      if (reLen.test(val)) {
        ++count
      }
      if (count == 5) {
        $('.pswArea').removeClass('errorInput').find('.warning').removeClass('info')
        return true
      }
      if ($('.pswArea').hasClass('errorInput')) {
        $('.pswArea').find('.warning').removeClass('info')
      } else {
        $('.pswArea').find('.warning').addClass('info')
      }
      return false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const params = new URLSearchParams(location.search.slice(1))

      if (params.get('email')) {
        vm.$store.state.userInfo.email = params.get('email')
        vm.$store.state.emailCode = params.get('activeCode')
      }
    })
  },
  filters: {
    getStrength (val) {
      switch (val) {
        case 2:
          return 'Low'
        case 4:
          return 'Middle'
        case 6:
          return 'High'
        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.warning {
  &.info {
    display: inline-block !important;
    .warningTip {
      color: #505050 !important;
    }
    .el-icon-warning-outline {
      color: #505050 !important;
    }
  }
}
</style>
